import React from "react";
import VoiceInputSection from '../../../default/components/VoiceInputSection.jsx';
import {AllergiesVoiceSection, ComplaintsVoiceSection, DiagnosisVoiceSection} from '../../components/VoiceInputs';
import TextInputs from '../../components/TextInputs';
import {Box} from "components-lib";
/**
 * MedicalInputSection Component
 *
 * Handles the medical input section that switches between voice and text input modes
 * Contains parameters, allergies, complaints, diagnosis, and advice input components
 * Conditionally renders sections based on doctor profile settings
 */
/*
  Note: this component receives `templateData` (prop) from `PatientDetails`.
  When `templateData` changes it is forwarded to `TextInputs` which is the
  main funnel that breaks template data into complaints/advices/medicines and
  calls `onDataChange` to update patientData setters.

  For full flow details see `docs/LOAD_TEMPLATE_FLOW.md`.
*/

const MedicalInputSection = ({
                                 isSpeechToTextEnabled,
                                 patientData,
                                 patientActions,
                                 appointment_id,
                                 doctor_id,
                                 templateData,
                                 PastpatientSpecifcData,
                                 appointmentPrescription,
                                 handleSubmit
                             }) => {
    // Get doctor profile settings from localStorage
    const getDoctorProfileSettings = () => {
        try {
            const profileData = localStorage.getItem('currentDoctorProfile');
            if (profileData) {
                const profile = JSON.parse(profileData);
                return {
                    isParameters: profile.isParameters === 1,
                    speech_to_text: profile.speech_to_text === 1
                };
            }
        } catch (error) {
            console.warn('Error parsing doctor profile settings:', error);
        }
        return {
            isParameters: false,
            speech_to_text: false
        };
    };

    const {isParameters, speech_to_text} = getDoctorProfileSettings();

    // Only show speech to text if enabled for this doctor
    const shouldShowSpeechToText = speech_to_text && isSpeechToTextEnabled;

    console.log('🔥 MedicalInputSection - Doctor settings:', {
        isParameters,
        speech_to_text,
        isSpeechToTextEnabled,
        shouldShowSpeechToText
    });


    // useEffect(() => {
    //   console.log("🔴 Template Data Recived at Medical Input section  " + JSON.stringify(templateData))
    // }, [templateData])


    return (
        <Box
            borderWidth="1px"
            borderColor="gray.200"
            // borderRadius="12px"
            p={{base: "4px", md: "24px"}}
            bg="white"
            boxShadow="sm"
            // mb={6}
            mt={6}
        >
            {shouldShowSpeechToText ? (
                <>
                    {/* Voice Input Components */}
                    {isParameters && (
                        <VoiceInputSection
                            title="parameters"
                            type="parameters"
                            initialData={{
                                bp: '--/--',
                                pulse: '--',
                                weight: '--',
                                spo2: '--',
                                height: '--',
                                temperature: '--'
                            }}
                        />
                    )}

                    <AllergiesVoiceSection
                        medicines={patientData.medicines}
                        food={patientData.food}
                        other={patientData.other}
                    />

                    <ComplaintsVoiceSection
                        complaints={patientData.complaints}
                    />

                    <DiagnosisVoiceSection
                        diagnosisList={patientData.diagnosis}
                    />

                    <VoiceInputSection
                        title="Advice"
                        type="text"
                        initialData={{text: ''}}
                    />
                </>
            ) : (
                /* Text Input Component */
                <Box>
                    <TextInputs
                        PastpatientSpecifcData={PastpatientSpecifcData}
                        templateData={templateData}
                        appointmentPrescription={appointmentPrescription}
                        onDataChange={(data) => {
                            console.log('🔥 MedicalInputSection - onDataChange called with:', data);
                            console.log('🔥 Clinical findings in data:', data.clinical_findings);

                            // Update parent component state with TextInputs data
                            if (data.complaints) patientData.setComplaints(data.complaints);
                            if (data.diagnosis) patientData.setDiagnosis(data.diagnosis);
                            if (data.medicines) patientData.setMedicines(data.medicines);
                            if (data.food) patientData.setFood(data.food);
                            if (data.other) patientData.setOther(data.other);
                            if (data.advice) patientData.setAdvicesData(data.advice);
                            if (data.clinical_findings) {
                                console.log('🔥 Setting clinical findings data:', data.clinical_findings);
                                patientData.setClinicalFindingsData(data.clinical_findings);
                            }
                            const pastHistoryIncoming = data.PastHistoryData || data.PastHistory;
                            if (pastHistoryIncoming) {
                                console.log('🔥 Setting Past History data:', pastHistoryIncoming);
                                patientData.setPastHistoryData(pastHistoryIncoming);
                            }
                        }}
                        onAddparameters={patientActions.handleAddparameters}
                        initialparameters={patientData.parameters || {}}
                        doctorRecommendations={patientData.apiRecommendations}
                        appointment_id={appointment_id}
                        handleSubmit={handleSubmit}//parameters
                        doctor_id={doctor_id}
                        // Pass the parameters visibility flag
                        showParameters={isParameters}
                        // NEW: bump to resync internal state after template apply
                        // templateSyncToken={patientData.templateSyncToken}
                        // externalComplaints={patientData.complaints}
                        // externalAdvices={patientData.advicesData}
                    />
                </Box>
            )}
        </Box>
    );
};

export default MedicalInputSection;